<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-4">
        <label>Nome</label>
        <input type="text" class="form-control" v-model="filters.nome" />
      </div>
      <div class="col-md-4">
        <label>Descrição</label>
        <input type="text" class="form-control" v-model="filters.descricao" />
      </div>
      <div class="col-md-4">
        <label>Rota</label>
        <v-select
          :options="rotas"
          :reduce="(rotas) => rotas.id"
          :label="'nome'"
          v-model="filters.rotas"
        ></v-select>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button class="btn btn-primary" @click="getVeiculos">Filtrar</button>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="limparFiltros">
          Limpar filtros
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="col-md-12 mt-1 text-right">
            <button class="btn btn-primary" @click="add">Novo Veiculo</button>
          </div>
          <div class="ibox">
            <div class="ibox-title" style="padding: 16px">
              <h3>Veículos</h3>
            </div>
            <div class="ibox-content">
              <div class="table-responsive" style="padding: 10px">
                <table
                  class="VueTables__table table table-striped table-bordered table-hover"
                  style="padding: 10px"
                >
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">NOME</th>
                      <th scope="col">DESCRIÇÃO</th>
                      <th scope="col">ROTA</th>
                      <th scope="col">AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="veiculo in veiculos" :key="veiculo.id">
                      <td>{{ veiculo.id }}</td>
                      <td>{{ veiculo.nome }}</td>
                      <td>{{ veiculo.descricao }}</td>
                      <td>
                        {{
                          veiculo.rotas[0]
                            ? veiculo.rotas[0].rota.nome
                            : "Sem Rota"
                        }}
                      </td>
                      <td>
                        <router-link
                          :to="'/veiculos/edit/' + veiculo.id"
                          title="Editar"
                          class="btn btn-crud edit"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </router-link>
                        <!-- <button
                          class="btn btn-crud delete"
                          @click="deleteVeiculo(veiculo.id)"
                          title="Deletar"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
                >
                  <pagination
                    :records="total"
                    :options="options"
                    :per-page="15"
                    @paginate="getVeiculos"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";

export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
      veiculos: [],
      filters: {
        id: "",
        nome: "",
        descricao: "",
        rotas: "",
      },
      rotas: [],
    };
  },
  components: {
    vSelect,
    Pagination,
  },

  methods: {
    deleteVeiculo(veiculoId) {
      const self = this;
      let api = self.$store.state.api + "veiculos/" + veiculoId;

      swal({
        title: "Deseja excluir este veículo?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, excluir!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O veículo não foi excluído!", "info");
            break;

          case "confirm":
            axios
              .delete(api)
              .then((response) => {
                self.getVeiculos();
                swal(
                  "Sucesso!",
                  "O veículo foi excluído com sucesso!",
                  "success"
                );
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });

            break;
        }
      });
    },
    add(props, row, index) {
      const self = this;
      this.$router.push("/veiculos/add");
    },
    getVeiculos(page) {
      const self = this;

      self.page = page || 1;

      self.$loading(true);

      let api = self.$store.state.api + "veiculos_post?page=" + self.page;

      axios
        .post(api, self.filters)
        .then((response) => {
          self.veiculos = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    getRotas: function () {
      const self = this;
      const api = self.$store.state.api + "rotas?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.rotas = response.data.data;

          self.rotas.push({id: 'null', nome: 'Sem rota'});
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    limparFiltros() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.getVeiculos();
    },
  },
  mounted() {
    this.getRotas();
    this.getVeiculos();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>